import { ThemeProvider } from "@mui/material";
import { ConfigProvider } from "antd";
import { antdTheme, themeMui } from "./theme/Theme";
import { BrowserRouter } from "react-router-dom";
import { MainContainer } from "./components/containers/MainContainer";
import { useState } from "react";
import { AppContext } from "./context/useAppContext";

function App() {
  const [contextData, setContextData] = useState({});

  return (
    <AppContext.Provider value={{ contextData, setContextData }}>
      <ThemeProvider theme={themeMui}>
        <ConfigProvider theme={antdTheme}>
          <BrowserRouter>
            <MainContainer />
          </BrowserRouter>
        </ConfigProvider>
      </ThemeProvider>
    </AppContext.Provider>
  );
}

export default App;
